@if(loaderService.loading()){
<div class="loader">
  <img src="assets/images/B-saffron.svg" alt="loader">
</div>
}
